module.exports = __webpack_public_path__ + "static/media/Spotify_logo_without_text.c863e113.svg";